import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useFormik, Form, FormikProvider } from "formik";
import {
  Input,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  // FormControl,
} from "reactstrap";
import { enquirySubmit } from "../../appRedux/actions/common";

const INITIAL_STATE = {
  name: "",
  email: "",
  contactNumber: "",
  // subject: "",
  message: "",
  product: "",
};

function EnquiryForm({ productName }) {
  const [productError, setProductError] = useState(false);
  const [product, setProduct] = useState(productName);
  const { productList } = useSelector((state) => ({
    productList: state.product.productList,
  }));
  //setProductError

  const [dropdownOpen, setOpen] = useState(false);

  const toggle = () => setOpen(!dropdownOpen);
  const [enquiry, setEnquiry] = useState(INITIAL_STATE);
  const dispach = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (productName && productName !== "") {
      setEnquiry({
        ...INITIAL_STATE,
        product: productName,
      });
    } else {
      //console.log("");
      setEnquiry({
        ...INITIAL_STATE,
      });
    }
  }, [productName]);

  const EnquirySchema = Yup.object().shape({
    email: Yup.string()
      .email("Email must be a valid email address.")
      .required("Email is required."),
    name: Yup.string().required("Name is required."),
    contactNumber: Yup.string().required("Contact number is required."),
    // subject: Yup.string().min(6).required("Subject is required."),
    message: Yup.string().min(6).required("Message is required."),
    product: Yup.string().required("Product is required"),
  });

  const formik = useFormik({
    enableReinitialize: productName && productName !== "" ? true : false,
    initialValues: enquiry,
    validationSchema: EnquirySchema,
    onSubmit: (data) => {
      console.log({ data });

      // sendMessage(data);
      // dispach(showLoader());

      dispach(
        enquirySubmit({
          ...data,
          subject: data.product + " Medicine Information Enquiry",
        })
      );
    },
  });

  const {
    errors,
    touched,
    values,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    getFieldProps,
  } = formik;
  console.log({ errors, touched });

  return (
    <section className="amit-contact-2  " id="contact">
      <div className="container ">
        <div className="contact-grids  ">
          <FormikProvider value={formik}>
            <Form
              id="contactForm"
              autoComplete="off"
              noValidate
              onSubmit={handleSubmit}
              className="signin-form"
            >
              {/* <form action="#" method="post" className="signin-form"> */}
              <div className="input-grids">
                <input
                  type="text"
                  placeholder="Your Name*"
                  className="contact-input"
                  name="name"
                  {...getFieldProps("name")}
                  error={Boolean(touched.name && errors.name)}
                />
                <p className="error-msg">{touched.name && errors.name}</p>
                <input
                  type="text"
                  placeholder="Your Contact Number*"
                  className="contact-input"
                  name="contactNumber"
                  {...getFieldProps("contactNumber")}
                  error={Boolean(touched.contactNumber && errors.contactNumber)}
                />
                <p className="error-msg">
                  {touched.contactNumber && errors.contactNumber}
                </p>
                <input
                  type="email"
                  placeholder="Your Email*"
                  className="contact-input"
                  name="email"
                  {...getFieldProps("email")}
                  error={Boolean(touched.email && errors.email)}
                />
                <p className="error-msg">{touched.email && errors.email}</p>
                {!productName && (
                  <>
                    <select
                      className="form-control"
                      disabled={productName ? true : false}
                      value={values.product}
                      onChange={(e) => {
                        if (e.target.value !== "select") {
                          let event = {
                            target: {
                              name: "product",
                              value: e.target.value,
                            },
                          };
                          handleChange(event);
                        }
                      }}
                      onBlur={() => {
                        handleBlur({ target: { name: "product" } });
                      }}
                    >
                      {!values.product && (
                        <option value="select">Select an Medicine</option>
                      )}
                      {productList.map((item) => {
                        return (
                          <option key={Math.random()} value={item.name}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                    <p className="error-msg">
                      {errors.product && touched.product && errors.product}
                      {/* {productError && "Select Medicine."} */}
                    </p>
                  </>
                )}

                <input
                  type="text"
                  name="Subject"
                  placeholder="Subject*"
                  className="contact-input"
                  required=""
                  hidden
                />
              </div>
              <div className="form-input">
                <textarea
                  placeholder="Type your message here*"
                  name="message"
                  {...getFieldProps("message")}
                  error={Boolean(touched.message && errors.message)}
                ></textarea>

                <p className="error-msg">{touched.message && errors.message}</p>
              </div>
              <div className="submit-amit-button text-lg-right">
                <button
                  type="submit"
                  className="btn btn-style btn-warning  py-2"
                >
                  Send Message
                </button>
              </div>
              {/* </form> */}
            </Form>
          </FormikProvider>
        </div>
      </div>
    </section>
  );
}

export default EnquiryForm;
